/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Day_To_Another_DaysInputs */



/**
* | output |
* | --- |
* | "Copy a day to other days" |
*
* @param {Copy_Day_To_Another_DaysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const copy_day_to_another_days = /** @type {((inputs?: Copy_Day_To_Another_DaysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Day_To_Another_DaysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Copy a day to other days")
	return /** @type {LocalizedString} */ ("Copier un jour vers d'autres jours")
});